const axios   = require('axios').default;
const L       = require('leaflet');
require('leaflet.markercluster');

class Mapbox {

  constructor() {
    this.access_token = 'pk.eyJ1IjoibGVubmFydGtvIiwiYSI6ImNrNDJ1dTdnOTAxNXkza3BqdmViNXJ0M3AifQ.7uaRvRm5YF79rZPMCPBNNA';
  }

  get_axios_instance(){
    return axios.create({
      timeout: 5000,
    });
  }

  address_to_geo_coordinates(address, cb){
    var search_address = encodeURIComponent(address);
    var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'+search_address+'.json?country=DE&language=de&types=address&access_token='+this.access_token;

    this.get_axios_instance().get( url )
    .then(function (response) {
      // console.log(response.data);

      var latitude  = '';
      var longitude = '';
      var address   = '';

      if (response.data.features && typeof(response.data.features[0]) != 'undefined'){
        longitude = response.data.features[0].geometry.coordinates[0];
        latitude  = response.data.features[0].geometry.coordinates[1];
        address   = response.data.features[0].place_name;
      }

      return cb({ latitude: latitude, longitude: longitude, address: address });
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, error.response.data);
    });
  }

  geo_coordinates_to_address(latitude, longitude, cb){
    var search_coords = longitude+','+latitude;
    var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'+search_coords+'.json?country=DE&types=address&access_token='+this.access_token;

    this.get_axios_instance().get( url )
    .then(function (response) {
      console.log(response.data);

      var street    = '';
      var city      = '';

      if (response.data.features && typeof(response.data.features[0]) != 'undefined'){
        var address = response.data.features[0].place_name;
        street  = address.split(', ')[0];
        city    = address.split(', ')[1];
      }

      return cb(street, city);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, error.response.data);
    });
  }

  add_map(div_id, options, cb){
    var map_init_options = {};
    map_init_options.zoomControl = ("zoomControl" in options ? options.zoomControl : true);
    
    var map   = new L.map(div_id, map_init_options);

    if (options.lat && options.lng){
      var zoom = ("zoom" in options ? options.zoom : 12);
      map.setView([options.lat, options.lng], zoom);
    }
    else {

      map.setView([53.55, 9.99], 12); // Hamburg

//      if (window.location.hostname == "hamburg.choiz.org"){
//        map.setView([53.55, 9.99], 12); // Hamburg
//      }
//      else {
//        map.setView([51.31, 9.47], 8); // Deutschland
//      }

    }

    var mapbox_url = 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token='+this.access_token;
    L.tileLayer(mapbox_url, { 
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
      maxNativeZoom:19,
      maxZoom:22
    }).addTo(map);

    return cb(map);
  }

  add_osm_map(div_id, options, cb){
    var osm_map   = new L.map(div_id).setView([53.55, 9.99], 12);
    var osmUrl    = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    var osmLayer  = new L.TileLayer(osmUrl, {
      maxZoom: 19,
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
    });
    osm_map.addLayer(osmLayer);
    return cb(osm_map);
  }

}

window.Mapbox = Mapbox;
